import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import FiltroComunicados from '../../Filtros/FiltroComunicados';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../InfoComponent';

class PlanoGestaoAdministrativa extends Component {

	render() {

		return (


			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>

				<InfoComponent image={"plano-de-gestao-administrativa"} page={'plano-de-gestao-administrativa'}></InfoComponent>		

				{/* <div className="_the-content page-noticias pt-10 mb-8"> */}
				<ErrorBoundary><FiltroComunicados url={"/ObterPlanoGestaoAdministrativa"} urlFiltro={"/ObterPlanoGestaoAdministrativa?"} /></ErrorBoundary>

				{/* Content page */}
				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default PlanoGestaoAdministrativa;